import React from "react";

export default function Bubble({ title }) {
  return <div style={$.container}>{title.toUpperCase()}</div>;
}

const $ = {
  container: {
    position: "absolute",
    top: -6,
    right: -6,
    color: "white",
    fontWeight: "bold",
    fontSize: 10,
    backgroundColor: "#1fc8db",
    padding: 4,
    borderRadius: 8,
  },
};
